<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		d="M13.0888 8.68258L5.86444 12.8722C5.27341 13.215 4.5 12.828 4.5 12.1896V3.81038C4.5 3.17195 5.27341 2.78505 5.86445 3.1278L13.0888 7.31742C13.6371 7.63535 13.6371 8.36465 13.0888 8.68258Z"
		fill="currentColor"
	/>
</svg>
